<template>
  <div class="bet-slip-settings" :class="{ open: open }" id="bet-slip-settings">
    <icon-button class="settings-button" @click="open = !open">
      <i-settings :title="null" />
    </icon-button>
    <drop-board position="bottom" v-show="open">
      <div class="question">{{ $t('bet-slip.settings.changes.question') }}</div>
      <radio-group
        name="quote-changes"
        :value="quoteChanges"
        :buttons="changesButtons"
        @change="changeChanges" />
    </drop-board>
  </div>
</template>

<script>
import ISettings from 'vue-material-design-icons/Settings'
import IconButton from '@/components/buttons/IconButton'
import RadioGroup from '@/components/forms/RadioGroup'
import DropBoard from '@/components/DropBoard'
import { mapState } from 'vuex'

export default {
  components: { ISettings, IconButton, RadioGroup, DropBoard },
  computed: {
    ...mapState({
      quoteChanges: state => state.user.settings.quoteChanges
    })
  },
  data () {
    return {
      open: false,
      changesButtons: [
        { text: 'bet-slip.settings.changes.ever', value: 1 },
        { text: 'bet-slip.settings.changes.when-lowered', value: 2 },
        { text: 'bet-slip.settings.changes.never', value: 3 }
      ]
    }
  },
  mounted () {
    document.addEventListener('click', this.handleDocumentClick.bind(this))
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleDocumentClick)
  },
  methods: {
    handleDocumentClick (event) {
      let target = event.target || event.srcElement
      if (!target.closest('#bet-slip-settings')) {
        this.open = false
      }
    },
    changeChanges (value) {
      this.$store.dispatch('SET_USER_SETTING', {
        name: 'quoteChanges',
        value: value
      })
    }
  }
}
</script>

<style scoped>
.bet-slip-settings { font-size: 14px; position: relative; }

.settings-button { color: #fff; font-size: 18px; }
.open.bet-slip-settings .settings-button > span { -webkit-transform: rotate(-30deg); -moz-transform: rotate(-30deg); -o-transform: rotate(-30deg); transform: rotate(-30deg); }

.drop-board { /* padding: 2px; */ right: -12px; }
.drop-board:before { right: 27px; }
.drop-board .question { line-height: normal; padding: 5px 7px; }
</style>



// WEBPACK FOOTER //
// src/components/bet-slip/BetSlipSettings.vue